<template>
  <article class="relative flex h-full border-r-2 border-solid border-app-green rounded-xl bg-white md:flex-col md:border-r-0 md:border-b-2">
    <div class="relative flex w-full h-full md:flex-col">
      <div class="relative shrink-0 rounded-l-xl overflow-hidden md:w-full md:rounded-l-none md:rounded-t-xl">
        <div class="c-animal-card-picture c-animal-card-picture--portrait relative block h-full md:h-auto">
          <AtomPreloader class="absolute inset-0" />
          <!-- TODO: Upgrade TailWindCSS to version 3 to support arbitrary values
                    https://tailwindcss.com/docs/min-width#arbitrary-values
                    <AtomPreloader class="w-[120px] h-[129px] media_sm:w-[258px] h-[222px] media_md:w-[228px] h-[197px] media_lg:w-[286px] h-[247px] media_xl:w-[330px] h-[285px]" />
                -->
          <picture class="block w-full h-full invisible">
            <source media="(min-width: 1750px)" width="330" height="285" />
            <source media="(min-width: 1280px)" width="286" height="247" />
            <source media="(min-width: 1024px)" width="228" height="197" />
            <source media="(min-width: 768px)" width="258" height="222" />
            <img width="120" height="129" loading="lazy" />
          </picture>
        </div>
      </div>
      <div class="flex flex-col p-4 2xl:px-8 2xl:py-5 md:px-6">
        <div>
          <h4 class="text-black mb-2 font-bold leading-none uppercase">
            <AtomPreloader class="relative mb-2 w-40 h-4" />
          </h4>
        </div>
        <div class="flex flex-wrap items-center mb-1 w-full text-sm font-bold leading-tight md:mb-2">
          <AtomPreloader class="mr-1 w-20 h-4" />
          <span class="mr-1 text-gray-400">•</span>
          <AtomPreloader class="w-20 h-4" />
        </div>
        <div class="flex items-center text-sm">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-labelledby="LocationPin" role="img" class="inline-block mr-1 w-3 h-3 text-app-green">
            <path
              fill="#cbd5e0"
              d="M18.7 2.8C16.9 1 14.5 0 12 0S7.1 1 5.3 2.8 2.5 6.9 2.5 9.5c0 8 8.5 14.1 8.9 14.3.2.1.4.2.6.2s.4-.1.6-.2c.4-.3 8.9-6.3 8.9-14.3 0-2.6-1-4.9-2.8-6.7zm-6.7 9c-1.3 0-2.3-1-2.3-2.3s1-2.3 2.3-2.3 2.3 1 2.3 2.3-1 2.3-2.3 2.3z"
            />
          </svg>
          <AtomPreloader class="mr-1 w-20 h-4" />
        </div>
      </div>
    </div>
  </article>
</template>
